import { useQuery } from "@tanstack/react-query";
import { Alert } from "../../types";
import { alertService } from "../../services/alertsService";

export const useAlerts = () => {
  return useQuery<Alert[]>({
    queryKey: ["alerts"],
    queryFn: async () => alertService.list(),
  });
};

